import React, { memo } from "react";

const OptimizedCard = memo(({ item }) => {
  return (
    <div 
      className="w-full group transition-all duration-300"
      /* Ускоряем рендеринг вне экрана */
      style={{ contentVisibility: 'auto', containIntrinsicSize: '350px' }}
    >
      <div
        className="
          relative overflow-hidden
          /* Используем transform-gpu для плавности */
          transform-gpu 
          will-change-transform
          backface-visibility-hidden
          
          /* Границы только на десктопе, так как на мобилках отрисовка border-b/r может тормозить скролл */
          md:border-r-8 md:border-b-8 md:border-yellow-500
          transition-transform duration-300
          md:group-hover:-translate-y-2
        "
      >
        {/* IMAGE CONTAINER */}
        <div className="h-[300px] md:h-[450px] w-full overflow-hidden bg-slate-800">
          <img
            src={item.img}
            loading="lazy"
            decoding="async"
            className="
              w-full h-full object-cover
              transform-gpu
              transition-transform duration-500
              md:group-hover:scale-105
              pointer-events-none
            "
            alt={item.name}
          />
        </div>

        {/* INFO */}
        <div className="p-3 md:p-5 bg-[#01305a] group-hover:bg-[#0058a3] h-[80px] md:h-auto transition-colors duration-300">
          <h3 className="text-white uppercase font-['Cormorant_Garamond'] text-[13px] md:text-[20px] leading-tight">
            {item.name}
          </h3>
          <span className="text-yellow-500 text-[10px] md:text-[12px] uppercase tracking-widest mt-1 block">
            {item.work}
          </span>
        </div>
      </div>
    </div>
  );
});

export default OptimizedCard;